"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GeometryState_drawingToolsId, _GeometryState_drawingToolsManager, _GeometryState_eventListenerTokens, _GeometryState_eventEngine, _GeometryState_geometryManager, _GeometryState_parentNode, _GeometryState_settings, _GeometryState_viewport, _GeometryState_closeLoop, _GeometryState_defaultTextures, _GeometryState_geometryDataLines, _GeometryState_geometryDataPoints, _GeometryState_indicesArrayLines, _GeometryState_materialIndexArray, _GeometryState_positionArray, _GeometryState_metadataArray, _GeometryState_positionIndexArray, _GeometryState_temporaryIndices, _GeometryState_wasWithinMinimumMaximumPointsRange;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryState = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const IDrawingToolsManager_1 = require("../../../interfaces/IDrawingToolsManager");
class GeometryState {
    // #endregion Properties (16)
    // #region Constructors (1)
    constructor(drawingToolsManager, geometryManager) {
        // #region Properties (16)
        _GeometryState_drawingToolsId.set(this, void 0);
        _GeometryState_drawingToolsManager.set(this, void 0);
        _GeometryState_eventListenerTokens.set(this, []);
        _GeometryState_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _GeometryState_geometryManager.set(this, void 0);
        _GeometryState_parentNode.set(this, void 0);
        _GeometryState_settings.set(this, void 0);
        _GeometryState_viewport.set(this, void 0);
        _GeometryState_closeLoop.set(this, false);
        _GeometryState_defaultTextures.set(this, void 0);
        _GeometryState_geometryDataLines.set(this, void 0);
        _GeometryState_geometryDataPoints.set(this, void 0);
        _GeometryState_indicesArrayLines.set(this, void 0);
        _GeometryState_materialIndexArray.set(this, []);
        _GeometryState_positionArray.set(this, void 0);
        _GeometryState_metadataArray.set(this, []);
        _GeometryState_positionIndexArray.set(this, void 0);
        _GeometryState_temporaryIndices.set(this, []);
        _GeometryState_wasWithinMinimumMaximumPointsRange.set(this, false);
        __classPrivateFieldSet(this, _GeometryState_geometryManager, geometryManager, "f");
        __classPrivateFieldSet(this, _GeometryState_drawingToolsId, drawingToolsManager.uuid, "f");
        __classPrivateFieldSet(this, _GeometryState_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _GeometryState_settings, drawingToolsManager.settings, "f");
        __classPrivateFieldSet(this, _GeometryState_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _GeometryState_parentNode, geometryManager.parentNode, "f");
        __classPrivateFieldSet(this, _GeometryState_defaultTextures, drawingToolsManager.defaultTextures, "f");
        __classPrivateFieldGet(this, _GeometryState_eventListenerTokens, "f").push((0, viewer_1.addListener)(viewer_1.EVENTTYPE_DRAWING_TOOLS.ADDED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _GeometryState_parentNode, "f").id)
                return;
            if (event.temporary === false) {
                if (event.index !== undefined) {
                    // shift the temporary indices
                    __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").map((i) => (i > event.index ? i + 1 : i)), "f");
                }
                else if (event.indices !== undefined) {
                    __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").map((i) => {
                        let shift = 0;
                        for (const index of event.indices) {
                            if (i > index)
                                shift++;
                        }
                        return i + shift;
                    }), "f");
                }
            }
            else if (event.temporary === true) {
                if (event.index !== undefined) {
                    __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").push(event.index);
                }
                else if (event.indices !== undefined) {
                    __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").push(...event.indices);
                }
            }
        }));
        __classPrivateFieldGet(this, _GeometryState_eventListenerTokens, "f").push((0, viewer_1.addListener)(viewer_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _GeometryState_parentNode, "f").id)
                return;
            if (event.temporary === false) {
                if (event.index !== undefined) {
                    // shift the temporary indices
                    __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").map((i) => (i > event.index ? i - 1 : i)), "f");
                }
                else if (event.indices !== undefined) {
                    __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").map((i) => {
                        let shift = 0;
                        for (const index of event.indices) {
                            if (i > index)
                                shift++;
                        }
                        return i - shift;
                    }), "f");
                }
            }
            else if (event.temporary === true) {
                if (event.index !== undefined) {
                    __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").filter((i) => i !== event.index), "f");
                }
                else if (event.indices !== undefined) {
                    __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").filter((i) => !event.indices.includes(i)), "f");
                }
            }
        }));
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (12)
    get closeLoop() {
        return __classPrivateFieldGet(this, _GeometryState_closeLoop, "f");
    }
    set closeLoop(value) {
        __classPrivateFieldSet(this, _GeometryState_closeLoop, value, "f");
        this.updateData(__classPrivateFieldGet(this, _GeometryState_positionArray, "f"), __classPrivateFieldGet(this, _GeometryState_metadataArray, "f"), true);
    }
    get geometryData() {
        return __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f");
    }
    get geometryDataLines() {
        return __classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f");
    }
    get geometryDataPoints() {
        return __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f");
    }
    get indicesArrayLines() {
        return __classPrivateFieldGet(this, _GeometryState_indicesArrayLines, "f");
    }
    get materialIndexArray() {
        return __classPrivateFieldGet(this, _GeometryState_materialIndexArray, "f");
    }
    get metadataArray() {
        return __classPrivateFieldGet(this, _GeometryState_metadataArray, "f");
    }
    get pointsLength() {
        return __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length / 3;
    }
    get positionArray() {
        return __classPrivateFieldGet(this, _GeometryState_positionArray, "f");
    }
    get positionIndexArray() {
        return __classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f");
    }
    get wasWithinMinimumMaximumPointsRange() {
        return __classPrivateFieldGet(this, _GeometryState_wasWithinMinimumMaximumPointsRange, "f");
    }
    set wasWithinMinimumMaximumPointsRange(value) {
        __classPrivateFieldSet(this, _GeometryState_wasWithinMinimumMaximumPointsRange, value, "f");
    }
    // #endregion Public Getters And Setters (12)
    // #region Public Methods (17)
    canAddPoint(number = 1) {
        if (this.wasWithinMinimumMaximumPointsRange === true &&
            __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.strictMinMaxPoints === true) {
            return (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.maxPoints !== undefined &&
                this.pointsLength + number <= __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.maxPoints);
        }
        return true;
    }
    canRemovePoint(number = 1) {
        if (this.wasWithinMinimumMaximumPointsRange === true &&
            __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.strictMinMaxPoints === true) {
            return (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.minPoints !== undefined &&
                this.pointsLength - number >= __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.minPoints);
        }
        return true;
    }
    checkMaximumNumberOfPoints(number) {
        if (number === undefined)
            number = __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length / 3;
        if (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.maxPoints === undefined)
            return true;
        return number <= __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.maxPoints;
    }
    checkMinimumNumberOfPoints(number) {
        if (number === undefined)
            number = __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length / 3;
        if (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.minPoints === undefined)
            return true;
        return number >= __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.minPoints;
    }
    checkNumberOfPoints(number) {
        return (this.checkMinimumNumberOfPoints(number) &&
            this.checkMaximumNumberOfPoints(number));
    }
    close() {
        __classPrivateFieldGet(this, _GeometryState_eventListenerTokens, "f").forEach((token) => (0, viewer_1.removeListener)(token));
        __classPrivateFieldGet(this, _GeometryState_eventListenerTokens, "f").length = 0;
        __classPrivateFieldGet(this, _GeometryState_parentNode, "f").removeData(__classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f"));
        if (__classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f"))
            __classPrivateFieldGet(this, _GeometryState_parentNode, "f").removeData(__classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f"));
    }
    convertToFloat32Array(points) {
        const positionArray = new Float32Array(points.length * 3);
        for (let i = 0; i < points.length; i++) {
            positionArray.set(points[i], i * 3);
        }
        return positionArray;
    }
    /**
     * Creates the indices array for the lines
     * Each line segment consists of two indices, start and end point
     *
     * optionally connect the last point with the first point
     */
    createLineIndices(loop) {
        if (!__classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f"))
            return;
        const positionArrayLength = __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length / 3;
        if (positionArrayLength < 1)
            return;
        const segmentCount = positionArrayLength - 1;
        let indicesArrayLines = new Uint8Array(segmentCount * 2);
        // create indices array with direct writes (avoids temp [i, i+1] arrays per iteration)
        for (let i = 0; i < segmentCount; i++) {
            const offset = i * 2;
            indicesArrayLines[offset] = i;
            indicesArrayLines[offset + 1] = i + 1;
        }
        if (loop) {
            // connect the last point with the first point
            const tempIndicesArray = new Uint8Array(indicesArrayLines.length + 2);
            tempIndicesArray.set(indicesArrayLines);
            tempIndicesArray[indicesArrayLines.length] =
                positionArrayLength - 1;
            tempIndicesArray[indicesArrayLines.length + 1] = 0;
            indicesArrayLines = tempIndicesArray;
        }
        return indicesArrayLines;
    }
    getPointCount() {
        return this.pointsLength;
    }
    getPointsData() {
        const points = [];
        for (let i = 0; i < __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length; i += 3) {
            points.push([
                __classPrivateFieldGet(this, _GeometryState_positionArray, "f")[i],
                __classPrivateFieldGet(this, _GeometryState_positionArray, "f")[i + 1],
                __classPrivateFieldGet(this, _GeometryState_positionArray, "f")[i + 2],
            ]);
        }
        return points;
    }
    getPosition(index) {
        return gl_matrix_1.vec3.fromValues(__classPrivateFieldGet(this, _GeometryState_positionArray, "f")[index * 3], __classPrivateFieldGet(this, _GeometryState_positionArray, "f")[index * 3 + 1], __classPrivateFieldGet(this, _GeometryState_positionArray, "f")[index * 3 + 2]);
    }
    init() {
        const geometryProperties = __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry;
        const points = geometryProperties.points;
        if (geometryProperties.points.length > 0) {
            if (geometryProperties.mode === "lines") {
                // as in Rhino a closed line is a polyline with the first and last point being the same
                // we need to remove the last point if it is the same as the first point
                // due to JavaScript floating point precision we need to check if the values are within a certain range
                const eps = 0.0000001;
                if (Math.abs(points[0][0] - points[points.length - 1][0]) <
                    eps &&
                    Math.abs(points[0][1] - points[points.length - 1][1]) <
                        eps &&
                    Math.abs(points[0][2] - points[points.length - 1][2]) < eps) {
                    points.pop();
                }
            }
            __classPrivateFieldSet(this, _GeometryState_positionArray, new Float32Array(points.length * 3), "f");
            // Build a map of all incoming points so applyConstraints can evaluate
            // size constraints against other points without touching geometryState
            // (which is not yet available at this point in construction).
            const allIncoming = new Map(points.map((p, i) => [i, gl_matrix_1.vec3.fromValues(p[0], p[1], p[2])]));
            const constrained = [].concat(...points.map((p, i) => {
                const overrides = new Map(allIncoming);
                overrides.delete(i);
                return Array.from(__classPrivateFieldGet(this, _GeometryState_drawingToolsManager, "f").applyConstraints(gl_matrix_1.vec3.fromValues(p[0], p[1], p[2]), i, overrides));
            }));
            __classPrivateFieldGet(this, _GeometryState_positionArray, "f").set(constrained);
            __classPrivateFieldSet(this, _GeometryState_metadataArray, new Array(points.length).fill(undefined), "f");
        }
        else {
            __classPrivateFieldSet(this, _GeometryState_positionArray, new Float32Array(), "f");
        }
        __classPrivateFieldSet(this, _GeometryState_geometryDataPoints, new viewer_1.GeometryData(new viewer_1.PrimitiveData({
            POSITION: new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_positionArray, "f"), 3, 12, 0, 4, false, __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length),
        }), viewer_shared_types_1.PRIMITIVE_MODE.POINTS), "f");
        __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").renderOrder = 1000;
        if (geometryProperties.mode !== "points") {
            __classPrivateFieldSet(this, _GeometryState_indicesArrayLines, new Uint8Array(), "f");
            __classPrivateFieldSet(this, _GeometryState_geometryDataLines, new viewer_1.GeometryData(new viewer_1.PrimitiveData({
                POSITION: new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_positionArray, "f"), 3, 12, 0, 4, false, __classPrivateFieldGet(this, _GeometryState_positionArray, "f").length),
            }, new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_indicesArrayLines, "f"), 1, 2, 0, 2, false, 0)), viewer_shared_types_1.PRIMITIVE_MODE.LINES), "f");
            __classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f").renderOrder = 999;
            __classPrivateFieldGet(this, _GeometryState_parentNode, "f").addData(__classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f"));
            if (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.close &&
                this.checkNumberOfPoints(points.length))
                __classPrivateFieldSet(this, _GeometryState_closeLoop, true, "f");
            __classPrivateFieldSet(this, _GeometryState_indicesArrayLines, this.createLineIndices(__classPrivateFieldGet(this, _GeometryState_closeLoop, "f") ||
                (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.close &&
                    __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.autoClose)), "f");
        }
        __classPrivateFieldGet(this, _GeometryState_parentNode, "f").addData(__classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f"));
        // create material index array
        __classPrivateFieldSet(this, _GeometryState_materialIndexArray, new Array(1024).fill(0), "f");
        // Apply DISABLED material for any disabled points
        const disabledPoints = __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.disabledPoints;
        if (disabledPoints) {
            for (const idx of disabledPoints) {
                __classPrivateFieldGet(this, _GeometryState_materialIndexArray, "f")[idx] = IDrawingToolsManager_1.MATERIAL_INDEX.DISABLED;
            }
        }
        __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").material = new viewer_1.MaterialMultiPointData(Object.assign({
            materialIndexDataMap: new viewer_1.MapData(new Image(), {
                asData: true,
                data: __classPrivateFieldGet(this, _GeometryState_materialIndexArray, "f"),
            }),
            materialIndexDataMapSize: 1024,
            alphaMode: viewer_shared_types_1.MATERIAL_ALPHA.BLEND,
            depthTest: false,
            depthWrite: false,
            transparent: true,
        }, __classPrivateFieldGet(this, _GeometryState_settings, "f").visualization.points));
        const updateMaterialVariation = (variations, map) => {
            for (const v of variations) {
                __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").material[v] = map;
            }
            __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").material.updateVersion();
            __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").updateVersion();
        };
        const variations = [
            "map_0",
            "map_1",
            "map_2",
            "map_3",
            "map_4",
            "map_5",
            "map_6",
            "map_7",
        ];
        if (__classPrivateFieldGet(this, _GeometryState_defaultTextures, "f").variation_0 instanceof viewer_1.MapData) {
            updateMaterialVariation(variations, __classPrivateFieldGet(this, _GeometryState_defaultTextures, "f").variation_0);
        }
        else {
            __classPrivateFieldGet(this, _GeometryState_defaultTextures, "f").variation_0.then((map) => {
                updateMaterialVariation(variations, map);
            });
        }
        // Override specific map slots with any URL strings supplied in the settings.
        // Object.assign above copies the raw string values but they are overwritten
        // by the default-texture pass above, so we need to load and re-apply them.
        const pointSettings = __classPrivateFieldGet(this, _GeometryState_settings, "f").visualization.points;
        // if a single "map" property is provided, use it for all variations
        if (pointSettings["map"]) {
            const mapValue = pointSettings["map"];
            if (typeof mapValue === "string") {
                viewer_1.MaterialEngine.instance.loadMap(mapValue).then((map) => {
                    if (map)
                        updateMaterialVariation(variations, map);
                });
            }
        }
        // if specific "map_0" to "map_7" properties are provided, use them for the corresponding variations
        for (const key of variations) {
            const settingValue = pointSettings[key];
            if (typeof settingValue === "string") {
                viewer_1.MaterialEngine.instance.loadMap(settingValue).then((map) => {
                    if (map)
                        updateMaterialVariation([key], map);
                });
            }
        }
        if (__classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f")) {
            __classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f").material = new viewer_1.MaterialBasicLineData(Object.assign({
                alphaMode: viewer_shared_types_1.MATERIAL_ALPHA.BLEND,
                depthTest: false,
                depthWrite: false,
                transparent: true,
            }, __classPrivateFieldGet(this, _GeometryState_settings, "f").visualization.lines));
        }
        this.updateData(__classPrivateFieldGet(this, _GeometryState_positionArray, "f"), __classPrivateFieldGet(this, _GeometryState_metadataArray, "f"));
    }
    makePointPersistent(index, recordHistory = true) {
        // check if the number of points is within the minimum and maximum range
        this.wasWithinMinimumMaximumPointsRange = this.checkNumberOfPoints();
        // remove from the temporary indices
        __classPrivateFieldSet(this, _GeometryState_temporaryIndices, __classPrivateFieldGet(this, _GeometryState_temporaryIndices, "f").filter((i) => i !== index), "f");
        __classPrivateFieldGet(this, _GeometryState_eventEngine, "f").emitEvent(viewer_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, {
            viewportId: __classPrivateFieldGet(this, _GeometryState_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _GeometryState_drawingToolsId, "f"),
            points: this.getPointsData(),
            metaData: __classPrivateFieldGet(this, _GeometryState_metadataArray, "f"),
            temporary: false,
            recordHistory,
        });
    }
    updateData(positionArray, metadataArray, temporary = false, fromHistory = false) {
        __classPrivateFieldSet(this, _GeometryState_positionArray, positionArray, "f");
        __classPrivateFieldSet(this, _GeometryState_metadataArray, metadataArray, "f");
        __classPrivateFieldSet(this, _GeometryState_positionIndexArray, this.createAndSetPositionIndexArray(), "f");
        // Note: createAndSetPositionIndexArray() above already creates and assigns
        // POSITION_INDEX AttributeData for both points and lines, so we only need
        // to update the POSITION attribute here.
        this.geometryDataPoints.primitive.attributes["POSITION"] =
            new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_positionArray, "f"), this.geometryDataPoints.primitive.attributes["POSITION"]
                .itemSize, this.geometryDataPoints.primitive.attributes["POSITION"]
                .itemBytes, this.geometryDataPoints.primitive.attributes["POSITION"]
                .byteOffset, this.geometryDataPoints.primitive.attributes["POSITION"]
                .elementBytes, this.geometryDataPoints.primitive.attributes["POSITION"]
                .normalized, this.geometryDataPoints.primitive.attributes["POSITION"].count -
                1);
        this.geometryDataPoints.updateVersion();
        this.geometryDataPoints.primitive.updateVersion();
        if (this.geometryDataLines) {
            __classPrivateFieldSet(this, _GeometryState_indicesArrayLines, this.createLineIndices(__classPrivateFieldGet(this, _GeometryState_closeLoop, "f") ||
                (__classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.close &&
                    __classPrivateFieldGet(this, _GeometryState_settings, "f").geometry.autoClose)), "f");
            if (__classPrivateFieldGet(this, _GeometryState_indicesArrayLines, "f")) {
                this.geometryDataLines.primitive.indices = new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_indicesArrayLines, "f"), this.geometryDataLines.primitive.indices.itemSize, this.geometryDataLines.primitive.indices.itemBytes, this.geometryDataLines.primitive.indices.byteOffset, this.geometryDataLines.primitive.indices.elementBytes, this.geometryDataLines.primitive.indices.normalized, __classPrivateFieldGet(this, _GeometryState_indicesArrayLines, "f").length);
            }
            this.geometryDataLines.primitive.attributes["POSITION"] =
                new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_positionArray, "f"), this.geometryDataLines.primitive.attributes["POSITION"]
                    .itemSize, this.geometryDataLines.primitive.attributes["POSITION"]
                    .itemBytes, this.geometryDataLines.primitive.attributes["POSITION"]
                    .byteOffset, this.geometryDataLines.primitive.attributes["POSITION"]
                    .elementBytes, this.geometryDataLines.primitive.attributes["POSITION"]
                    .normalized, this.geometryDataLines.primitive.attributes["POSITION"]
                    .count - 1);
            // Note: POSITION_INDEX for lines is already set by createAndSetPositionIndexArray()
            this.geometryDataLines.updateVersion();
            this.geometryDataLines.primitive.updateVersion();
        }
        if (temporary === false) {
            // check if the number of points is within the minimum and maximum range
            this.wasWithinMinimumMaximumPointsRange =
                this.checkNumberOfPoints();
        }
        __classPrivateFieldGet(this, _GeometryState_eventEngine, "f").emitEvent(viewer_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, {
            viewportId: __classPrivateFieldGet(this, _GeometryState_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _GeometryState_drawingToolsId, "f"),
            points: this.getPointsData(),
            metaData: __classPrivateFieldGet(this, _GeometryState_metadataArray, "f"),
            temporary,
            fromHistory,
        });
    }
    updateDataFromHistory(points, metadataArray) {
        const positionArray = this.convertToFloat32Array(points);
        this.updateData(positionArray, metadataArray, false, true);
    }
    updateMaterialIndexArray(materialIndexArray) {
        __classPrivateFieldSet(this, _GeometryState_materialIndexArray, materialIndexArray, "f");
        const threeJsPointsGeometry = __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f")
            .convertedObject[__classPrivateFieldGet(this, _GeometryState_viewport, "f").id];
        const material = threeJsPointsGeometry.material;
        const materialIndexDataTexture = material.materialIndexDataTexture;
        const materialIndexData = materialIndexDataTexture === null || materialIndexDataTexture === void 0 ? void 0 : materialIndexDataTexture.image.data;
        if (materialIndexDataTexture && materialIndexData) {
            for (let i = 0; i < __classPrivateFieldGet(this, _GeometryState_materialIndexArray, "f").length; i++)
                materialIndexData[i] = __classPrivateFieldGet(this, _GeometryState_materialIndexArray, "f")[i];
            materialIndexDataTexture.needsUpdate = true;
            material.needsUpdate = true;
        }
        ((__classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").material.materialIndexDataMap = new viewer_1.MapData(new Image(), {
            asData: true,
            data: __classPrivateFieldGet(this, _GeometryState_materialIndexArray, "f"),
        })),
            __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").material.updateVersion());
    }
    // #endregion Public Methods (17)
    // #region Private Methods (1)
    createAndSetPositionIndexArray() {
        const positionIndexArray = new Float32Array(__classPrivateFieldGet(this, _GeometryState_positionArray, "f").length / 3);
        // fill position index array with indices (direct write, avoids temp arrays from set([i], i))
        for (let i = 0; i < positionIndexArray.length; i++) {
            positionIndexArray[i] = i;
        }
        __classPrivateFieldSet(this, _GeometryState_positionIndexArray, positionIndexArray, "f");
        __classPrivateFieldGet(this, _GeometryState_geometryDataPoints, "f").primitive.attributes["POSITION_INDEX"] =
            new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f"), 1, 1, 0, 1, true, __classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f").length, [0], [__classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f").length]);
        if (__classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f"))
            __classPrivateFieldGet(this, _GeometryState_geometryDataLines, "f").primitive.attributes["POSITION_INDEX"] =
                new viewer_1.AttributeData(__classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f"), 1, 1, 0, 1, true, __classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f").length, [0], [__classPrivateFieldGet(this, _GeometryState_positionIndexArray, "f").length]);
        return positionIndexArray;
    }
}
exports.GeometryState = GeometryState;
_GeometryState_drawingToolsId = new WeakMap(), _GeometryState_drawingToolsManager = new WeakMap(), _GeometryState_eventListenerTokens = new WeakMap(), _GeometryState_eventEngine = new WeakMap(), _GeometryState_geometryManager = new WeakMap(), _GeometryState_parentNode = new WeakMap(), _GeometryState_settings = new WeakMap(), _GeometryState_viewport = new WeakMap(), _GeometryState_closeLoop = new WeakMap(), _GeometryState_defaultTextures = new WeakMap(), _GeometryState_geometryDataLines = new WeakMap(), _GeometryState_geometryDataPoints = new WeakMap(), _GeometryState_indicesArrayLines = new WeakMap(), _GeometryState_materialIndexArray = new WeakMap(), _GeometryState_positionArray = new WeakMap(), _GeometryState_metadataArray = new WeakMap(), _GeometryState_positionIndexArray = new WeakMap(), _GeometryState_temporaryIndices = new WeakMap(), _GeometryState_wasWithinMinimumMaximumPointsRange = new WeakMap();
//# sourceMappingURL=GeometryState.js.map